<template>
  <div class="customer-plugin">
    <ul class="exInfo">
      <li class="phone">
        <div class="onlyIcon1"></div>
        <div class="iconDesc">电话客服</div>
        <div class="phone-details"><p>咨询热线</p><p>4006004006</p></div>
      </li>
      <li class="wx">
        <div class="onlyIcon2"></div>
        <div class="iconDesc">公众号</div>
          <div class="wx-details">
              <p>关注并获取业务进度提醒</p>
              <img src="../../../assets/img/customer/erweima.jpg" alt="">
          </div>
      </li>
<!--      <li>-->
<!--        <div class="onlyIcon3"></div>-->
<!--        <div class="iconDesc">在线沟通</div>-->
<!--      </li>-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Customer'
}
</script>

<style lang="less" scoped>
.customer-plugin {
  position: fixed;
  width: 67px;
  height: 166px;
  padding: 0;
  text-align: center;
  border-radius: 33px;
  background-color: #3f70ed;
  right: 0;
  top: 50%;
  margin-top: -125px;
  cursor: pointer;
  z-index: 999;
  .icon {
    display: inline-block;
    width: 23px;
    height: 25px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 5px;
  }
  .iconDesc {
    color: #f5f5f5;
    font-size: 12px;
    line-height: 16px;
  }
  ul.exInfo {
      display: flex;
      flex-direction: column;
      height: 100%;
      li {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #3361d7;
        list-style: none;
        &:last-child {
          border-bottom: none;
        }
      }
      .triangle{
          content: '';
          display: block;
          position: absolute;
          width:0;
          height: 0;
          border-width: 5px;
          right:-10px;
          top:50%;
          margin-top: -5px;
          border-color: #fff;
          border-style: solid;
          border-right-color: transparent;
          border-top-color: transparent;
          border-bottom-color: transparent;
      }
      li.phone{
          .phone-details{
              display: none;
              position: absolute;
              width:150px;
              height: 60px;
              top:50%;
              margin-top: -30px;
              background-color: #fff;
              flex-direction: column;
              justify-content: center;
              right: 77px;
              border-radius: 10px;
              font-size: 12px;
              box-shadow: 0 0 10px #ccc;
              &::after{
                  .triangle()
              }
          }
          &:hover{
              .phone-details{
                  display: flex;
              }
          }
      }
      li.wx{
          .wx-details{
              position: absolute;
              width:150px;
              height: 140px;
              top:50%;
              margin-top: -70px;
              background-color: #fff;
              display: none;
              flex-direction: column;
              justify-content: center;
              right: 77px;
              border-radius: 10px;
              font-size: 12px;
              align-items: center;
              box-shadow: 0 0 10px #ccc;
              img{
                  width:100px;
              }
              &::after{
                  .triangle()
              }
          }
          &:hover{
              .wx-details{
                  display: flex;
              }
          }
      }
      li.phone:hover{

      }
  }
   .onlyIcon1 {
      .icon();
      background-image: url('../../../assets/img/customer/phone.png');
   }
   .onlyIcon2 {
     .icon();
     background-image: url('../../../assets/img/customer/wx.png');
   }
   .onlyIcon3 {
      .icon();
      background-image: url('../../../assets/img/customer/online.png');
   }
}
</style>



// WEBPACK FOOTER //
// src/components/inc/component/Customer.vue